import TlPrdctOrdrearn from "./DashboardADmin/TlPrdctOrdrearn";
import "./Dashboard.css";

const DashboardcomXKPbcadafcddcfadacbPKXproductlistsearchdashboard = () => {

return (

<div>
<TlPrdctOrdrearn></TlPrdctOrdrearn>
</div>

);

};

export default DashboardcomXKPbcadafcddcfadacbPKXproductlistsearchdashboard;
